import React, {useEffect, useState} from 'react';
import {requestCandidateGroups} from "@app/services/CandidateGroupService";
import MergeCandidateGroupModal from "@pages/savedlist/MergeCandidateGroupModal";
import {toast} from "react-toastify";
import {CANDIDATE_GROUP_ORDER_BY, DEFAULT_PAGE_SIZE} from "@app/constants/Common";
import {Props} from "react-select";
import {requestGetUserList} from "@app/services/UserService";
import CreateUserModal from "@pages/user/CreateUserModal";
import UserEmailsModal from "@pages/user/UserEmailsModal";

const UserList = (props) => {
    const [userList, setUserList] = useState([]);
    const [selectUser, setSelectUser] = useState("");
    const [showAddOrEditModal, setShowAddOrEditModal] = useState(false);
    const [showUserEmailsModal, setShowUserEmailsModal] = useState(false);
    const [orderBy, setOrderBy] = useState(CANDIDATE_GROUP_ORDER_BY.DESC_UPDATE_DATE);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const {title} = props

    const searchUserList = async (page, newOrderBy, searchInputConditions) => {
        setOrderBy(newOrderBy)
        setCurrentPage(page)
        setIsLoading(true)
        let params = {page: page, size: 20, order_by: newOrderBy}
        const res = await requestGetUserList(params);
        setIsLoading(false)
        setUserList(res.content.users);
    }

    useEffect(async (params) => {
        await searchUserList(currentPage, orderBy)
    }, []);

    const onViewDetailModal = async (index) => {
        setSelectUser(userList[index])
        setShowAddOrEditModal(true)
    }

    const onViewUserEmailsModal = async (index) => {
        setSelectUser(userList[index])
        setShowUserEmailsModal(true)
    }

    return (
        <div className="container-fluid">
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title">{title}</h3>
                    <div className={'card-tools'}>
                        <a href='#'
                           className='btn btn-success'
                           onClick={() => {
                               setShowAddOrEditModal(true)
                           }}
                           >
                            Add
                        </a>
                    </div>
                    {isLoading &&
                    <div className={'col-sm-12 text-center'}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                    }
                </div>
                <div className="card-body table-responsive p-0">
                    <table
                        className='table table-hover table-bordered text-nowrap text-center'
                    >
                        <thead>
                        <tr>
                            <th>No.</th>
                            <th>Họ và tên</th>
                            <th>Tên đăng nhập</th>
                            <th>Email</th>
                            {/*<th>Số ĐT</th>*/}
                            <th>Giới tính</th>
                            <th>Thời gian NL ưu tiên</th>
                            <th>Ngày tạo</th>
                            <th>Trạng thái</th>
                            <th>Hành động</th>
                        </tr>
                        </thead>
                        <tbody>
                        {userList && userList.length > 0 && userList.map((user, index) => (
                            <tr key={`candidate_${index}`}>
                                <td>{index + 1}</td>
                                <td>
                                    <b>
                                        <a href={'javascript:void(0)'} onClick={() => onViewDetailModal(index)}>
                                            {user.full_name}
                                        </a>
                                    </b>
                                </td>
                                <td>{user.username}</td>
                                <td>{user.email}</td>
                                {/*<td>{user.phone}</td>*/}
                                <td>{user.gender}</td>
                                {user.start_pri_input_date && user.end_pri_input_date ?
                                    <td>{user.start_pri_input_date} ~ {user.end_pri_input_date}</td>
                                    : <td> </td>
                                }
                                <td>{user.created_date_time}</td>
                                <td className={user.is_active ? 'text-success' : 'text-danger'}>{user.is_active ? 'Active' : 'Blocked'}</td>
                                <td>
                                    <button onClick={() => onViewUserEmailsModal(index)}
                                            type={'button'}
                                            className={'btn btn-default'}>
                                        Emails
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <CreateUserModal isShow={showAddOrEditModal}
                             userInput={selectUser}
                             onClose={(isSuccess, reload) => {
                                 setSelectUser("")
                                 setShowAddOrEditModal(false)
                                 searchUserList().then()
                                 if (isSuccess) {
                                     toast.success(`Lưu thông tin user thành công.`);
                                 } else if (isSuccess === false) {
                                     toast.error(`Lưu thông tin user thất bại.`);
                                 }
                             }}
            />
            {showUserEmailsModal &&
            <UserEmailsModal isShow={showUserEmailsModal}
                             userId={selectUser.id}
                             onClose={() => setShowUserEmailsModal(false)}
            />
            }
        </div>
    );
};

export default UserList;
